export default (error) => error.code === 422;
